import { render, staticRenderFns } from "./SLayout.vue?vue&type=template&id=546c112c&scoped=true"
import script from "./SLayout.vue?vue&type=script&lang=js"
export * from "./SLayout.vue?vue&type=script&lang=js"
import style0 from "./SLayout.vue?vue&type=style&index=0&id=546c112c&prod&lang=css"
import style1 from "./SLayout.vue?vue&type=style&index=1&id=546c112c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546c112c",
  null
  
)

export default component.exports